import { Flex, Image, Modal, Space } from "antd";
import { useEffect } from "react";
import _ from "lodash";

import { FALLBACK_IMAGE } from "config";
import {
  DETAIL_FIELDS,
  DETECTED_CODE_TYPE_COLOR_MAP,
  FIELD_KEYS,
  FIELD_LABELS,
  FIELD_ORDERS,
} from "constants/UnitFields";
import useFetch from "hooks/useFetch";
import StatusTag from "components/Common/StatusTag";

const fields = _.intersection(FIELD_ORDERS, DETAIL_FIELDS);

const UnitDetailsModal = ({ showModal, data, onClose, showDetailsModalUnitIndex }) => {
  const { responseData: unitImagesResponseData, doFetch: getUnitImages } =
    useFetch("/units/getUnitImages", "GET", []);
  const unitImagesData = unitImagesResponseData.data ?? [];

  const renderField = (key, val) => {
    switch (key) {
      case FIELD_KEYS.DETECTED_CODE:
        const fieldColor = !!val?.type
          ? DETECTED_CODE_TYPE_COLOR_MAP[val.type]
          : null;
        const fieldStyle = !!fieldColor
          ? {
              color: fieldColor,
            }
          : {};
        return <span style={fieldStyle}>{val?.value ?? "-"}</span>;
      case FIELD_KEYS.STATUS:
        return <StatusTag status={val} />;
      default:
        return val ?? "-";
    }
  };

  const fetchUnitImages = () => {
    if (data?.images?.length > 0) {
      getUnitImages({
        paths: data.images,
      });
    }
  };

  useEffect(()=>{
    if(showDetailsModalUnitIndex !== null){
      fetchUnitImages();
    }
  },[showDetailsModalUnitIndex])

  return (
    <>
      <Modal
        title="Unit Details"
        open={showModal}
        onCancel={onClose}
        footer={null}
        wrapClassName="modal-wrap-max-content"
        centered={true}
      >
        <Flex vertical={true} gap="middle" style={{ paddingTop: "1rem" }}>
          <Flex
            justify="center"
            wrap="wrap"
            gap="1rem 3rem"
            style={{ margin: "0 0.5rem" }}
          >
            {fields.map((fieldKey, index) => (
              <div key={index}>
                <Space>
                  <span style={{ fontWeight: "500" }}>
                    {FIELD_LABELS[fieldKey]}
                  </span>
                  : {renderField(fieldKey, data[fieldKey])}
                </Space>
              </div>
            ))}
          </Flex>
          <Flex wrap="wrap" gap="small" justify="center">
            {unitImagesData.length > 0 ? (
              <Image.PreviewGroup>
                {unitImagesData.map((image, index) => (
                  <>
                    <Flex
                      key={"unit_image_" + index}
                      align="center"
                      wrap="wrap"
                      vertical={true}
                    >
                      <span style={{ fontWeight: "700" }}>{image.name}</span>
                      {/* Fallback failed when image.data is undefined, had to check in src and assign fallback image in the src. */}
                      <Image
                        width={400}
                        height={400}
                        src={image.data ?? FALLBACK_IMAGE}
                        fallback={FALLBACK_IMAGE}
                      />
                    </Flex>
                  </>
                ))}
              </Image.PreviewGroup>
            ) : (
              <Image
                width={400}
                height={400}
                src="error"
                fallback={FALLBACK_IMAGE}
              />
            )}
          </Flex>
        </Flex>
      </Modal>
    </>
  );
};

export default UnitDetailsModal;
